import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * Get the pointer X position in pixels within an element at the provided ref.
 * Supports single-point touch interactions too.
 */

export function useMousePosition(ref) {
  var refForMostRecentlyComputedValue = useRef(0);
  var refForRaf = useRef(0);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  var setPositionOnNextAnimationFrame = useCallback(function () {
    window.cancelAnimationFrame(refForRaf.current);
    refForRaf.current = null;
    setPosition(refForMostRecentlyComputedValue.current);
  }, []);
  var onMouseMoveOrTouch = useCallback(function (event) {
    var _ref, _ref$touches, _ref$current;

    var isTouchEvent = Boolean((_ref = event) === null || _ref === void 0 ? void 0 : (_ref$touches = _ref.touches) === null || _ref$touches === void 0 ? void 0 : _ref$touches[0]);
    var eventPosition = isTouchEvent ? event.touches[0].clientX : event.clientX;
    var elementPosition = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect().left;
    var distanceFromLeftOfElement = eventPosition - elementPosition;
    var nextPosition = Math.max(0, distanceFromLeftOfElement);
    refForMostRecentlyComputedValue.current = nextPosition;

    if (!refForRaf.current) {
      refForRaf.current = window.requestAnimationFrame(setPositionOnNextAnimationFrame);
    }
  }, [ref, setPositionOnNextAnimationFrame]);
  useEffect(function () {
    var element = ref.current;

    if (element) {
      element.addEventListener('mousemove', onMouseMoveOrTouch);
      element.addEventListener('touchstart', onMouseMoveOrTouch);
      element.addEventListener('touchmove', onMouseMoveOrTouch);
    }

    return function () {
      if (element) {
        element.removeEventListener('mousemove', onMouseMoveOrTouch);
        element.removeEventListener('touchstart', onMouseMoveOrTouch);
        element.removeEventListener('touchmove', onMouseMoveOrTouch);
      }
    };
  }, [onMouseMoveOrTouch, ref]);
  useEffect(function () {
    return function () {
      window.cancelAnimationFrame(refForRaf.current);
    };
  }, []);
  return position;
}